import React, { useEffect, useState } from "react";
import { useApi } from "../../context/ApiProvider";
import OrganisationTree from "../Helpers/OrganisationTree";
import { useLocale } from "../../localization/LocaleProvider";

export default function Organisations() {

  const Api = useApi();
  const [organisations, setOrganisations] = useState(false);
  const { translate } = useLocale();

  useEffect(() => {
    fetchOrganisations()
  }, [])

  const fetchOrganisations = () => {
    Api.get("/organisations").then(result => {
      setOrganisations(result);
    }).catch(error => {
      console.log(error);
    })
  }



  return (<>
    <h2>{translate("List of organisations")}</h2>
    <div className="grid-container">
      {organisations && organisations.map(function (client, index) {
        return (
          <section key={index}>
            <ul className="tree">
              <li>
                <strong>{client.name}</strong>
              <OrganisationTree organisations={client.organisations} />
              </li>
            </ul>
          </section>
        )
      })}
    </div>
  </>)
}